module.exports = __webpack_public_path__ + "static/media/avatar.c638fb01.jpg";